import { render, staticRenderFns } from "./platformList.vue?vue&type=template&id=8c824d14&scoped=true"
import script from "./platformList.vue?vue&type=script&lang=js"
export * from "./platformList.vue?vue&type=script&lang=js"
import style0 from "./platformList.vue?vue&type=style&index=0&id=8c824d14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c824d14",
  null
  
)

export default component.exports